import React from "react";

export const Field: React.FC<{ label: string; value?: string; children: React.ReactNode }> = ({ label, value, children }) => (
  <div className="col" style={{ gap: 6 }}>
    <div className="row" style={{ justifyContent: "space-between", fontSize: 12 }}><span style={{ fontWeight: 600 }}>{label}</span>{value !== undefined ? <span className="muted">{value}</span> : null}</div>
    {children}
  </div>
);

export const Slider: React.FC<{ label: string; value: number; min: number; max: number; step?: number; format?: (v: number) => string; onChange: (v: number) => void }> = ({ label, value, min, max, step = 1, format, onChange }) => (
  <Field label={label} value={format ? format(value) : String(value)}>
    <input type="range" min={min} max={max} step={step} value={value} onChange={(e) => onChange(Number(e.target.value))} style={{ ["--fill" as any]: `${((value - min) / (max - min)) * 100}%` }} />
  </Field>
);

export const Toggle: React.FC<{ label: string; checked: boolean; onChange: (v: boolean) => void }> = ({ label, checked, onChange }) => (
  <label className="row" style={{ justifyContent: "space-between", fontSize: 12, cursor: "pointer" }}>
    <span style={{ fontWeight: 600 }}>{label}</span>
    <span onClick={() => onChange(!checked)} style={{ width: 38, height: 22, borderRadius: 11, background: checked ? "var(--green)" : "var(--line)", position: "relative", transition: "background 120ms" }}><span style={{ position: "absolute", top: 3, left: checked ? 19 : 3, width: 16, height: 16, borderRadius: "50%", background: "#fff", transition: "left 120ms" }} /></span>
  </label>
);

export const Segmented: React.FC<{ options: { value: string; label: string }[]; value: string; onChange: (v: string) => void }> = ({ options, value, onChange }) => (
  <div className="seg">
    {options.map((o) => <button key={o.value} className={value === o.value ? "on" : ""} onClick={() => onChange(o.value)}>{o.label}</button>)}
  </div>
);

const PALETTE = ["#F7F5EF", "#FFFFFF", "#F5C542", "#22B14C", "#7DD3FC", "#F0A39A", "#0B0F0D", "#1B4D2E"];
export const ColorPick: React.FC<{ label: string; value: string; onChange: (v: string) => void }> = ({ label, value, onChange }) => (
  <div className="col" style={{ gap: 5, alignItems: "center" }}>
    <label style={{ position: "relative", width: 30, height: 30, borderRadius: "50%", background: value, border: "2px solid var(--line)", cursor: "pointer", display: "block" }}>
      <input type="color" value={/^#[0-9a-f]{6}$/i.test(value) ? value : "#ffffff"} onChange={(e) => onChange(e.target.value)} style={{ position: "absolute", inset: 0, opacity: 0, width: "100%", height: "100%", cursor: "pointer" }} />
    </label>
    <span className="muted" style={{ fontSize: 11 }}>{label}</span>
    <div className="row" style={{ gap: 3 }}>{PALETTE.map((c) => <span key={c} onClick={() => onChange(c)} style={{ width: 10, height: 10, borderRadius: "50%", background: c, border: c === value ? "1px solid var(--gold)" : "1px solid var(--line)", cursor: "pointer" }} />)}</div>
  </div>
);
